module.exports = __webpack_public_path__ + "img/map2.1487d8f6.png";